/* My Leadout - app shell (23 Oct 2026). Runs only when the site is opened from the home screen (html.lo-app,
   set by the inline script in snippets/lo-app-head.liquid). Adds a top bar, bottom tabs and a splash screen;
   the website itself is unchanged. */
(function () {
  var H = document.documentElement;
  if (!H.classList.contains('lo-app')) return;
  var C = window.LO_APP || {};
  var root = C.root || '/';
  var path = location.pathname;
  var onHub = /\/pages\/my-leadout\/?$/.test(path);
  var onLab = /\/pages\/leadout-lab/.test(path) || /\/products\/leadout-lab/.test(path);
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // ---- splash (first thing, so there is never a white page)
  var splash = document.createElement('div');
  splash.className = 'lo-splash';
  splash.innerHTML = '<img src="' + esc(C.icon) + '" alt=""><span>My Leadout</span>';
  (document.body || H).appendChild(splash);
  var shown = Date.now();
  function ready() {
    var wait = Math.max(0, 450 - (Date.now() - shown));      // stay long enough not to flash
    setTimeout(function () { H.classList.add('lo-ready'); setTimeout(function () { splash.remove(); }, 400); }, wait);
  }
  if (onHub) {       // wait for the dashboard to draw (or give up after 2.5s)
    var done = false, t = setTimeout(function () { if (!done) { done = true; ready(); } }, 2500);
    var hub = document.getElementById('lo-hub');
    if (hub && hub.children.length) { done = true; clearTimeout(t); ready(); }
    else if (hub) { var mo = new MutationObserver(function () { if (!done && hub.children.length) { done = true; clearTimeout(t); mo.disconnect(); ready(); } }); mo.observe(hub, { childList: true }); }
    else { done = true; clearTimeout(t); ready(); }
  } else {
    if (document.readyState === 'complete') ready(); else window.addEventListener('load', ready);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // ---- top bar
    var title = (document.title || '').split(/\s[–|-]\s/)[0].trim() || 'My Leadout';
    if (onHub) title = 'My Leadout';
    var top = document.createElement('div');
    top.className = 'lo-top';
    top.innerHTML = '<button type="button" class="lo-back" aria-label="Back"' + (onHub || history.length < 2 ? ' hidden' : '') + '>&#8249;</button>' +
      '<img src="' + esc(C.icon) + '" alt=""><b>' + esc(title) + '</b>' +
      '<a class="lo-tp" href="https://app.trainingpeaks.com/" target="_blank" rel="noopener">TrainingPeaks</a>';
    top.querySelector('.lo-back').addEventListener('click', function () { if (history.length > 1) history.back(); else location.href = root + 'pages/my-leadout'; });
    document.body.appendChild(top);

    // ---- bottom tabs: Dashboard / Lab / Coach / Subscriptions & bookings. On the dashboard each tab is its own screen
    var I = {
      today: '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="17" rx="3"/><path d="M3 9h18M8 2v4M16 2v4"/><circle cx="12" cy="15" r="1.6" fill="currentColor" stroke="none"/></svg>',
      week: '<svg viewBox="0 0 24 24"><path d="M4 19V9M10 19V5M16 19v-8M22 19H2"/></svg>',
      lab: '<svg viewBox="0 0 24 24"><path d="M9 3h6M10 3v6L4 20a1.5 1.5 0 0 0 1.3 2h13.4A1.5 1.5 0 0 0 20 20L14 9V3"/><path d="M7 15h10"/></svg>',
      coach: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>',
      account: '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="3"/><path d="M3 10h18M7 15h4"/></svg>'
    };
    var hubUrl = root + 'pages/my-leadout';
    var VIEWS = ['today', 'coach', 'account'];
    var TITLES = { today: 'My Leadout', coach: 'Your coach', account: 'Subscriptions & bookings' };
    var tabs = document.createElement('nav');
    tabs.className = 'lo-tabs';
    tabs.setAttribute('aria-label', 'My Leadout');
    tabs.innerHTML =
      '<a href="' + hubUrl + '" data-tab="today">' + I.today + 'Dashboard</a>' +
      '<a href="' + root + 'pages/leadout-lab" data-tab="lab">' + I.lab + 'Lab</a>' +
      '<a href="' + hubUrl + '#coach" data-tab="coach">' + I.coach + 'Coach</a>' +
      '<a href="' + hubUrl + '#account" data-tab="account">' + I.account + 'Bookings</a>';
    document.body.appendChild(tabs);
    var links = tabs.querySelectorAll('a');
    function setOn(name) { [].forEach.call(links, function (a) { a.classList.toggle('on', a.dataset.tab === name); }); }
    var hashView = location.hash.replace('#', '');
    setOn(onLab ? 'lab' : onHub ? (VIEWS.indexOf(hashView) > 0 ? hashView : 'today') : '');

    // which screen each dashboard card belongs to (by its heading)
    var CD = null; try { var cdEl = document.getElementById('lo-coach-data'); CD = cdEl ? JSON.parse(cdEl.textContent) : null; } catch (x) { CD = null; }
    var hasCoach = !!(CD && CD.name);
    function viewOf(card) {
      if (card.classList.contains('lo-acct')) return 'account';
      if (card.classList.contains('lo-coach') || card.classList.contains('lo-coach-cal') || card.classList.contains('lo-coaches')) return 'coach';
      var h = card.querySelector('h2, .lo-utoggle b'); var t = h ? h.textContent.trim().toLowerCase() : '';
      if (!hasCoach && /^(update my training|your training, your week)/.test(t)) return 'coach';   // Adaptive Programming: no named coach
      return 'today';
    }
    // Coach screen: the coach card, then their booking calendar inline (same Google appointment page the card's button opens)
    function coachCal(hub) {
      if (!hasCoach || !CD.book || !/^https?:/.test(CD.book) || hub.querySelector('.lo-coach-cal')) return;
      var u = CD.book; if (/calendar\.google\.com\/calendar\/appointments/.test(u) && !/[?&]gv=true/.test(u)) u += (u.indexOf('?') < 0 ? '?' : '&') + 'gv=true';
      var c = document.createElement('div'); c.className = 'lo-card lo-span-12 lo-coach-cal';
      c.innerHTML = '<h2>Book a call <small>pick a time that suits you</small></h2><iframe src="' + esc(u) + '" title="Book a call with ' + esc(CD.name) + '" loading="lazy"></iframe>' +
        '<p class="lo-rdnote">You’ll get a calendar invite with a video link. <a href="' + esc(CD.book) + '" target="_blank" rel="noopener">Open the calendar in a new tab</a> if it doesn’t load.</p>';
      var card = hub.querySelector('.lo-coach'); var grid = hub.querySelector('.lo-grid');
      if (card && card.parentNode) card.parentNode.insertBefore(c, card.nextSibling); else if (grid) grid.appendChild(c);
    }
    // No designated coach (Adaptive Programming): the way to get one
    function coachesCard(hub) {
      if (hasCoach || hub.querySelector('.lo-coaches')) return;
      var c = document.createElement('div'); c.className = 'lo-card lo-span-12 lo-coaches';
      c.innerHTML = '<div class="lo-coach-k">1-2-1 Performance Coaching</div><h2>Want a coach in your corner?</h2>' +
        '<p class="lo-app-how">Your Adaptive Programming plan is written and checked by the Leadout coaching team. Move up to 1-2-1 and you get a designated Leadout coach: daily feedback on every session, a plan built around your life, and a call whenever you need one.</p>' +
        '<div class="lo-actions" style="margin-top:14px"><a class="lo-btn" href="' + esc(root) + 'products/1-2-1-performance-coaching">Upgrade to 1-2-1 coaching</a>' +
        '<a class="lo-btn ghost" href="' + esc(root) + 'pages/coaching">What’s included</a></div>';
      var grid = hub.querySelector('.lo-grid'); if (grid) grid.insertBefore(c, grid.firstChild);
    }
    function show(view) {
      var hub = document.getElementById('lo-hub'); if (!hub) return;
      hub.dataset.view = view;
      if (view === 'coach') { coachCal(hub); coachesCard(hub); }
      var any = false;
      [].forEach.call(hub.querySelectorAll('.lo-card'), function (c) { var on = viewOf(c) === view; c.hidden = !on; if (on) any = true; });
      var hero = hub.querySelector('.lo-hero'); if (hero) hero.hidden = view !== 'today';
      var empty = hub.querySelector('.lo-view-empty'); if (!any && view !== 'today') {
        if (!empty) { empty = document.createElement('div'); empty.className = 'lo-card lo-span-12 lo-view-empty'; var g = hub.querySelector('.lo-grid'); if (g) g.appendChild(empty); }
        empty.hidden = false; empty.innerHTML = '<p class="lo-rest">Nothing here yet.</p>';
      } else if (empty) empty.hidden = true;
      var tb = document.querySelector('.lo-top b'); if (tb) tb.textContent = TITLES[view] || 'My Leadout';
      window.scrollTo({ top: 0 });
      setOn(view);
      try { history.replaceState(null, '', view === 'today' ? hubUrl : '#' + view); } catch (x) {}
    }
    if (onHub) {
      var hub = document.getElementById('lo-hub');
      var first = VIEWS.indexOf(hashView) > 0 ? hashView : 'today';
      function drawn() { return hub && hub.querySelector('.lo-card'); }
      if (drawn()) show(first);
      else if (hub) { var mo2 = new MutationObserver(function () { if (drawn()) { mo2.disconnect(); setTimeout(function () { show(first); }, 60); } }); mo2.observe(hub, { childList: true, subtree: true }); }
      // cards that arrive later (plan, fit, coach) get sorted into the right screen
      if (hub) new MutationObserver(function () { var v = hub.dataset.view; if (v) [].forEach.call(hub.querySelectorAll('.lo-card:not(.lo-view-empty)'), function (c) { c.hidden = viewOf(c) !== v; }); }).observe(hub, { childList: true, subtree: true });
      tabs.addEventListener('click', function (e) {
        var a = e.target.closest('a'); if (!a || a.dataset.tab === 'lab') return;
        e.preventDefault();
        if (!drawn()) { var btn = hub && hub.querySelector('.lo-empty .lo-btn'); if (btn && a.dataset.tab !== 'today') { btn.click(); return; } }
        show(a.dataset.tab);
        var c = hub.querySelector('[data-view] .lo-ucard .lo-utoggle[aria-expanded="false"]'); if (a.dataset.tab === 'coach' && c && !hub.querySelector('.lo-coach')) c.click();
      });
    }

    // external links open outside the app (TrainingPeaks, the shop, booking calendars)
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]'); if (!a) return;
      var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin && !a.target) a.target = '_blank';
    });
  });
})();
